import { jwtDecode } from 'jwt-decode';
import React, { createContext, useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState();
    const [cookies, setCookie, removeCookie] = useCookies(['tokenProf']);
    const jwtUser = (token, remember) => {
        const jwtUser = jwtDecode(token);
        if (jwtUser.username) {
            setUser(jwtUser);
            setCookie('tokenProf', token, { path: '/', expires: remember ? new Date(jwtUser.exp * 1000) : new Date(Date.now() + 3600 * 1000) });
            return true;
        } else {
            removeCookie('tokenProf', { path: '/' })
            setUser(false);
            return false;
        }
    }

    const logOut = () => {
        navigate('/sign-in')
        setTimeout(() => {
            removeCookie('tokenProf', { path: '/' });
        }, 1000);

    }
    const profile = cookies.tokenProf && jwtDecode(cookies.tokenProf).username ? jwtDecode(cookies.tokenProf) : false;
    return (
        <AuthContext.Provider value={{
            user, jwtUser, profile, logOut
        }}>
            {children}
        </AuthContext.Provider>
    );
};